import Seo from "../components/Seo";

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Notice | Dorothy Read Healing"
        description="How the Dorothy Read Healing website handles your personal information, in plain language."
        path="/privacy"
      />

      <section className="mx-auto max-w-3xl px-6 pb-20 pt-12 md:pt-20" data-testid="privacy-page">
        <p className="eyebrow">Privacy</p>
        <h1 className="mt-4 font-serif text-5xl font-semibold leading-[1.05] tracking-tight text-primary">
          Your privacy, in plain language
        </h1>
        <p className="mt-6 text-lg text-muted-foreground">Last reviewed: November 2026</p>

        <div className="mt-10 space-y-10 text-lg leading-relaxed">
          <section>
            <h2 className="font-serif text-3xl font-semibold text-primary">What the contact form collects</h2>
            <p className="mt-3">
              The only information this site asks for is what you type into the contact form: your name,
              your number, and any comments or requests you choose to add. Nothing else is collected,
              and there are no accounts or logins.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-3xl font-semibold text-primary">Where your message goes</h2>
            <p className="mt-3">
              Your message is sent straight to Dorothy&apos;s own email inbox as an ordinary email,
              delivered by the website&apos;s email service (Resend). It is not stored in a website
              database and it is not shared with anyone else. Dorothy reads it and replies to you
              personally, in her own time.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-3xl font-semibold text-primary">When Dorothy replies</h2>
            <p className="mt-3">
              If Dorothy calls or writes back, that conversation stays between you and her - this
              website is not involved.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-3xl font-semibold text-primary">Website analytics</h2>
            <p className="mt-3">
              The site counts simple, anonymous interactions - for example which pages are visited and
              whether visitors use the booking or contact buttons - so Dorothy can tell whether the site
              is doing its job. Nothing you type into the form is ever sent to the analytics service.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-3xl font-semibold text-primary">What never happens</h2>
            <ul className="mt-3 list-disc space-y-2 pl-6">
              <li>Your details are never sold or shared for advertising.</li>
              <li>There is no marketing list and no newsletter - you only hear back about your own enquiry.</li>
              <li>No account, password or login is needed to use this site.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-3xl font-semibold text-primary">Your choices</h2>
            <p className="mt-3">
              If you would like a message you sent to be deleted from Dorothy&apos;s inbox, just say so
              through the same contact form.
            </p>
          </section>
        </div>
      </section>
    </>
  );
}
